import React from 'react'
import slugify from 'slugify'
import { useSelector } from 'react-redux'
import { Link } from 'gatsby'

import trads from '../../intl/trads.json'

import LinkIcon from '../linkIcon'
import Image from '../image'
import Wysiwyg from '../wysiwyg'

import semiroundShape from '../../icons/semiround-shape.svg'
import hexagonShape from '../../icons/hexagon-shape.svg'

import transformLink from '../../utils/transformLink'

const OfferCard = ({offer}) => {
  const lang = useSelector(state => state.lang)
  const type = slugify(offer.fields ? offer.fields.solution.fields.solution : offer.solution.solution).toLowerCase()
  
  const url = transformLink(offer, false, false).url

  offer = (offer.fields) ? offer.fields : offer

  let hexagonColor = null
  let semiroundColor = null

  switch(type) {
    case 'methanisation':
      hexagonColor = 'gradient-green'
      semiroundColor = 'night'
      break
    case 'digital':
      hexagonColor = 'gradient-sienne'
      semiroundColor = 'orange'
      break
    case 'hydrogene':
      hexagonColor = 'gradient-purple'
      semiroundColor = 'turquoise'
      break
    case 'mobilite-bas-carbone':
      hexagonColor = 'gradient-aqua'
      semiroundColor = 'sienne'
      break
    case 'co2':
      hexagonColor = 'gradient-co2'
      semiroundColor = 'tumbleweed'
      break
    default:
      return 'error'
  }

  return (
    <Link to={url} className={`offer-card offer-card--${type}`}>
      <div className="offer-card__content">
        <div>
          <h3 className="offer-card__title font-semibold">{offer.title}</h3>
          <Wysiwyg classes="offer-card__txt" noClass={true} document={offer.chapo} />
        </div>
        <LinkIcon className="mt-4" iconColor="night" text={ trads[lang].learnMore } />
      </div>
      <div className="offer-card__img-wrap relative">
        <svg className={`offer-card__hexagon absolute icon-${hexagonColor}`} width="58" height="58">
          <use xlinkHref={hexagonShape.url} />
        </svg>
        <svg className={`offer-card__semiround absolute icon-${semiroundColor}`} width="43" height="57">
          <use xlinkHref={semiroundShape.url} />
        </svg>
        <Image
            image={offer.mainImage}
            width={320}
            height={400}
            classes="shaped-image shaped-image--offer-card object-fit-image"
            sizes={{"415": [367, 312], "767": [720, 611], "1023": [390, 400] }}
          />
      </div>
    </Link>
  )
}

export default OfferCard